import { environment } from "../environments/environment";


export class ApiUrl {
  static IMAGEFILEBASE = environment.baseUrl + "/api/image/";
  static LOGINBASEURL = environment.baseUrl + "/api/login";
  static LOGIN = this.LOGINBASEURL + "/auth/login";
  static REGISTRATION = this.LOGINBASEURL + "/signup";
  static VERIFYOTP = this.LOGINBASEURL + "/signup/verify";
  static FORGETPASSWORD = this.LOGINBASEURL + "/auth/forgotpassword";
  static FORGOTPASSWORDOTPVERIFY = this.LOGINBASEURL + "/auth/reset_otp_verification";
  static RESETPASSWORD = this.LOGINBASEURL + "/auth/reset_password";
  static REFRESHTOKEN = this.LOGINBASEURL + "/auth/refresh_token";
  static RESENTOTP = this.LOGINBASEURL + "/signup/resend_otp";
  static RENEWREFRESHTOKEN = this.LOGINBASEURL + "/auth/renew_refresh_token"

  // Image API
  static IMAGEAPI = environment.baseUrl + "/api/image";
  static RENDIFFUSSIONRESPONSESAVE = this.IMAGEAPI + "/save_processed_image";
  static IMAGEUPLOAD = this.IMAGEAPI + "/image_upload";
  static IMAGECROPPED = this.IMAGEAPI + "/cropped_image?image_id=";
  static IMAGEENHANCEMENT = this.IMAGEAPI + "/process_image";
  static IMAGESAVEGETENHANCEMENT = this.IMAGEAPI + "/save_input_image";
  static OUTPUTENHANCEMENT = this.IMAGEAPI + "/get_output_image";
  static OUTPUTENHANCEMENTIMAGEPATH = this.IMAGEAPI + "/uploads/";

  static rundiffussionSettings = this.IMAGEAPI + "/image_process_settings";
  static IMAGEPATH = this.IMAGEAPI + "/image_processing?image_id=";
  static FINALIMAGE = this.IMAGEAPI + "/final_select_image";

  static FAQLIST = environment.baseUrl + "/api/user/faq_list";
  static SMTP = environment.baseUrl + "/api/user/share_image_email";

  // Help & Support
  static HELPANDSUPPORT = environment.baseUrl + "/api/support";
  static LISTALLTICKETS = this.HELPANDSUPPORT + "/ticket/list";
  static TICKETDETAILS = this.HELPANDSUPPORT + "/ticket/view";
  static TICKETCOMMENT = this.HELPANDSUPPORT + "/ticket/update_comment_status";
  static CREATE_SUPPORT_TICKET = this.HELPANDSUPPORT + "/ticket/create";
  static SUPPORTCATEGORY = this.HELPANDSUPPORT + "/ticket/category";
  static CLOSETICKET = this.HELPANDSUPPORT + "/ticket/update_comment_status/";


  // Subscription
  static PAYMENTS = environment.baseUrl + "/api/payment";
  static PLANLIST = this.PAYMENTS + "/payment_plan/?order_by=desc&export=0&limit=1&payment_mode=online";
  static LOGOUT = this.LOGINBASEURL + "/auth/logout";
  static INVOICELIST = this.PAYMENTS + "/user_invoice_list/?page=0&limit=5";
  static PROCESSPAYMENT = this.PAYMENTS + "/process_payment/";
  static PROCESSLICENSE = this.PAYMENTS + "/upgrade_license/";
  static CHECKLICENSE = this.PAYMENTS + "/user_subscription_list/?order_by=desc";
  static LICENSEKEY = this.PAYMENTS + "/payment_history/?order_by=desc&export=0&limit=2&page=0";
  static PLANDETAILSFROMKEY = this.PAYMENTS + "/location_subscription_list/?order_by=desc";
  static PLANDETAILSONLINEOFFLINE = this.PAYMENTS + "/SaveSubscriptionMode";


  // Sub-Account Management
  static USERMANAGEMENTLIST = environment.baseUrl + "/api/user/list/users_admin";
  static USERAPI = environment.baseUrl + "/api/user/form_submit"
  static ROLE = environment.baseUrl + "/api/user/list/roles"
  static ISFULLACCESS = environment.baseUrl + "/api/user/user"

  // Static URL to redirect after registration and OTP verification
  static REDIRECTURL = "https://www.seebaby.ai/?page_id=4482";
  static REDIRECTURLHOME = "https://www.seebaby.ai";
  static REDIRECTURLFAQ = "https://www.seebaby.ai/?page_id=10437";
  static REDIRECTURLSUPPORT = "https://www.seebaby.ai/?page_id=10437";
  static STRIPEINTENT = environment.baseUrl + "/api/payment/create-payment-intent";
  static STRIPESUBSCRIPTION = environment.baseUrl + "/api/payment/create-subscription/";
  static STRIPEUPDATECARD = environment.baseUrl + "/api/payment/update-payment-method";
  static SUBSCRIPTIONCHECK = environment.baseUrl + "/api/payment/fetch-subscription/";
  static PAYEARLIER = environment.baseUrl + "/api/payment/pay-early/";
  static SUBCRIPTIONKEYSTRIPE = environment.baseUrl + "/api/payment/get_subscription_details";
  static SESSIONEXPIRETITLE = "Session Expired";
  static SESSIONEXPIREBODY = "Session expired, please log back in"
  static TRIALEXPIRETITLE = "Trial Expired / Trial Canceled";
  static TRIALEXPIREBODY = "Do you want to upgrade the plan?"
  static SWITCHPAYMENTMODE = "Switch mode";
  static SWITCHPAYMENTMODEBODY = "Are you sure you want to switch to offline mode?";
  static ACTIVATELICENCE= environment.baseUrl +"/api/payment/activate-license";
  static CHNAGEPASSWORD =  environment.baseUrl+"/api/user/change_password";
  static CHECKPASSWORD= environment.baseUrl+'/api/login/auth/verify-password';
  static UPGRADEPLANE=this.PAYMENTS+"/upgrade_subscription";

  // Storage API (referrals, media, etc.)
  static STORAGEAPI = environment.baseUrl + "/api/storage";

}
